<div class="e-input-group">
	<input
		#patientSearchInput
		[readOnly]="isPatientSet()"
		(keydown.enter)="openSearchPatientModal($event)"
		type="text"
		class="e-input"
		placeholder="Search Patients"
		[disabled]="disabled"
		[(ngModel)]="patientName"
		[ngModelOptions]="{standalone: true}"
		[revFocusInput]="isFocused"/>
	@if (!disabled && !isPatientSet() && !isPatientProvidedFromParent()) {
		<span
			(click)="openSearchPatientModal()"
			revTooltip
			tooltipContent="Search Patients"
			[attr.data-test-id]="'openSearchPatientModal'"
			class="e-input-group-icon fa fa-user">
		</span>
	}
	@if (shouldShowPatientNavigateButton()) {
		<span
			#openPatient
			(click)="navigateToPatient()"
			[attr.data-test-id]="'openCurrentPatient'"
			class="e-input-group-icon fa fa-folder-open">
		</span>
	}
	@if (!disabled && displayAlertsFlagButton()) {
		<span
			(click)="displayStatusAlertsModal()"
			revTooltip tooltipContent="View Alerts"
			[attr.data-test-id]="'openPatientAlerts'"
			class="e-input-group-icon fa fa-flag text-{{firstSortedActiveAlert.severity.label | severityClass}}">
		</span>
	}
	@if (!disabled && isPatientSet() && !isPatientProvidedFromParent()) {
		<span
			(click)="clearPatient()"
			[attr.data-test-id]="'clearPatient'"
			class="e-input-group-icon fa fa-times">
		</span>
	}
	@if (!disabled && includeSelectPatientFromWaitList === true && !isPatientProvidedFromParent()) {
		<span
			(click)="openViewWaitList()"
			revTooltip tooltipContent="View Wait List"
			[attr.data-test-id]="'openViewWaitList'"
			class="e-input-group-icon fa fa-list">
		</span>
	}
	@if (!disabled && includeAddNewPatient === true && !isPatientProvidedFromParent()) {
		<span
			(click)="openAddPatientModal()"
			revTooltip tooltipContent="Add New Patient"
			[attr.data-test-id]="'openAddPatientModal'"
			class="e-input-group-icon fa fa-plus">
		</span>
	}
</div>
<div #patientTooltip [hidden]="true">
	<h5>{{ patientForPopover?.patientName | patientName }}</h5>
	<dl class='row'>
		<dt class="col-md-3">DOB</dt>
		<dd class="col-md-9">{{ patientForPopover?.dateOfBirth | date:dateType }}<br>({{ patientForPopover?.dateOfBirth | personAge }})
		</dd>
		<dt class="col-md-3">Sex</dt>
		<dd class="col-md-9">{{ patientForPopover?.gender.label }}</dd>
		<dt class="col-md-3">Address</dt>
		<dd class="col-md-9">
			{{ patientForPopover?.address?.address1 }}@if (patientForPopover?.address?.address2) {
			<span>, {{ patientForPopover?.address?.address2 }}</span>
		}
			<br>
			{{ patientForPopover?.address?.city }},
			{{ patientForPopover?.address?.stateProvince }}
			{{ patientForPopover?.address?.postalCode }}
		</dd>
		<dt class="col-md-3">Home</dt>
		<dd class="col-md-9">{{ patientForPopover?.phoneNumbers.homePhone }} {{ patientForPopover?.phoneNumbers.homePhoneExt }}
			@if (preferredPhoneType.HOME === patientForPopover?.phoneNumbers.preferredPhoneType) {
				<i
					class='fa fa-star text-success'></i>
			}</dd>
		<dt class="col-md-3">Work</dt>
		<dd class="col-md-9">{{ patientForPopover?.phoneNumbers.workPhone }} {{ patientForPopover?.phoneNumbers.workPhoneExt }}
			@if (preferredPhoneType.WORK === patientForPopover?.phoneNumbers.preferredPhoneType) {
				<i
					class='fa fa-star text-success'></i>
			}</dd>
		<dt class="col-md-3">Cell</dt>
		<dd class="col-md-9">{{ patientForPopover?.phoneNumbers.cellPhone }} {{ patientForPopover?.phoneNumbers.cellPhoneExt }}
			@if (preferredPhoneType.CELL === patientForPopover?.phoneNumbers.preferredPhoneType) {
				<i
					class='fa fa-star text-success'></i>
			}</dd>
		<dt class="col-md-3">Email</dt>
		<dd class="col-md-9">{{ patientForPopover?.email }}</dd>
		<dt class="col-md-3">PHR Login</dt>
		<dd class="col-md-9">{{ patientForPopover?.phrLogin ? "Yes" : "No" }}</dd>
	</dl>
</div>
